(() => {
  const root = document.querySelector('[data-spark-order-guide]');
  if (!root) return;

  const guide = root.dataset.sparkOrderGuideKey;
  const allowedGuides = new Set(['die-cut-stickers', 'roll-labels', 'label-sheets']);
  if (!allowedGuides.has(guide)) return;

  const publish = (eventName, payload = {}) => {
    const eventPayload = {
      guide,
      guide_version: '2026-07-25',
      page_path: window.location.pathname,
      ...payload,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName.replace(':', '_'),
      ...eventPayload,
    });

    try {
      const published = window.Shopify?.analytics?.publish(eventName, eventPayload);
      if (published && typeof published.catch === 'function') published.catch(() => {});
    } catch {
      // Analytics must never interrupt the guide or storefront navigation.
    }
  };

  publish('sparkstickers:order_guide_viewed');

  root.addEventListener('click', (event) => {
    const link = event.target.closest('[data-spark-order-guide-action]');
    if (!link || !root.contains(link)) return;

    publish('sparkstickers:order_guide_action', {
      action: link.dataset.sparkOrderGuideAction || '',
      label: link.dataset.sparkOrderGuideLabel || '',
    });
  });

  if (!('IntersectionObserver' in window)) return;

  const seenSteps = new Set();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const step = entry.target.dataset.orderStep;
      if (!step || seenSteps.has(step)) return;
      seenSteps.add(step);
      publish('sparkstickers:order_guide_step_viewed', { step });
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.45 });

  root.querySelectorAll('[data-order-step]').forEach((step) => observer.observe(step));
})();
